/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-northeast-1",
    "aws_cloud_logic_custom": [
        {
            "name": "apitei",
            "endpoint": "https://l3prfnels1.execute-api.ap-northeast-1.amazonaws.com/devlite",
            "region": "ap-northeast-1"
        }
    ],
    "aws_dynamodb_all_tables_region": "ap-northeast-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "dynamo01-devlite",
            "region": "ap-northeast-1"
        },
        {
            "tableName": "TodoTable-devlite",
            "region": "ap-northeast-1"
        }
    ],
    "aws_user_files_s3_bucket": "sample-vue-project-bucket164128-devlite",
    "aws_user_files_s3_bucket_region": "ap-northeast-1",
    "aws_cognito_identity_pool_id": "ap-northeast-1:d035376b-24bf-483e-9cfa-d1acd7c0aed6",
    "aws_cognito_region": "ap-northeast-1",
    "aws_user_pools_id": "ap-northeast-1_LZ5pjLtwV",
    "aws_user_pools_web_client_id": "2dcbdogr43qmltvmbf70m6gqoo",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
